/**
 * Cookie impostato da `/enable-device` → GET `/api/auth/enable-participant-device`.
 * Deve coincidere con `api/_lib/participantDeviceCookie.ts` lato server.
 */
export const PARTICIPANT_DEVICE_COOKIE_NAME = 'participantEnabled';
export const PARTICIPANT_DEVICE_COOKIE_VALUE = 'true';

function readCookieMap(): Record<string, string> {
  if (typeof document === 'undefined') return {};
  const out: Record<string, string> = {};
  for (const part of document.cookie.split(';')) {
    const p = part.trim();
    const eq = p.indexOf('=');
    if (eq < 0) continue;
    const k = p.slice(0, eq).trim();
    const v = decodeURIComponent(p.slice(eq + 1).trim());
    if (k) out[k] = v;
  }
  return out;
}

export function isParticipantDeviceEnabled(): boolean {
  return readCookieMap()[PARTICIPANT_DEVICE_COOKIE_NAME] === PARTICIPANT_DEVICE_COOKIE_VALUE;
}
